import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header
            headline="Pennsylvania Eviction Filings"
            subtitle="Pennsylvanians have filed for unemployment in record numbers in recent
            months. But even when the economy was doing well, thousands of people faced
            eviction proceedings each year. Move the slider to see how the rate of
            eviction filings has varied over time."
          />
          <Body data={data} />
          <Footer
            byline="Daniel Simmons-Ritchie"
            footnote="Eviction filing rate is a ratio of the number of evictions filed in an area compared to the number 
            of renter-occupied homes in that area. All eviction case filings are counted, including multiple cases 
            filed against the same address in the same year."
            source={
              <span>
                City-level data from the{" "}
                <a
                  href="https://evictionlab.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Eviction Lab
                </a>{" "}
                at Princeton University, 2006 to 2016.
              </span>
            }
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
